import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import {
  FaQuestionCircle,
  FaPlus,
  FaMinus,
  FaArrowRight,
  FaRocket,
  FaCheckCircle,
  FaWhatsapp,
} from "react-icons/fa";
import "./Faq.css";

const fadeUp = {
  hidden: { opacity: 0, y: 35 },
  visible: { opacity: 1, y: 0 },
};

/* ─── 30 FAQs ────────────────────────────────────────────────── */
export const faqs = [
  {
    q: "Who is Amresh Prajapati?",
    a: "Amresh Prajapati is a freelance website developer and digital marketing expert based in Virar West, Vasai-Virar, Maharashtra. With 4+ years of experience and 70+ completed projects, he specializes in building fast, modern, and SEO-ready websites for local businesses.",
  },
  {
    q: "What services does Amresh Prajapati offer?",
    a: "He offers custom website development, WordPress development, React JS development, HTML/CSS coding, professional SEO services, branding & digital marketing, and Google Business Profile management.",
  },
  {
    q: "Where is Amresh Prajapati located?",
    a: "His office is located at FRF4+572, Global City, J56, Rustomjee Ave, Evershine Global City, Dongarpada, Rustomjee Global City, Virar West, Vasai-Virar, Maharashtra 401303.",
  },
  {
    q: "Does Amresh Prajapati work with clients outside Virar?",
    a: "Yes, he serves clients across Mumbai, Vasai-Virar, Saphale, and other nearby areas, along with remote clients across India.",
  },
  {
    q: "Is Amresh Prajapati a React JS expert?",
    a: "Yes, he is a Custom React Expert and builds dynamic, component-based websites and web applications using React JS for businesses that need fast, scalable, and interactive websites.",
  },
  {
    q: "Does he build WordPress websites too?",
    a: "Yes, along with React JS, he is highly experienced in WordPress website development, customization, and CMS management.",
  },
  {
    q: "How many years of experience does Amresh Prajapati have?",
    a: "He has 4+ years of professional experience in website development and digital marketing.",
  },
  {
    q: "How many projects has he completed?",
    a: "He has successfully delivered 70+ websites and digital projects for clients across various industries.",
  },
  {
    q: "What is his typical project delivery time?",
    a: "Most websites are delivered within 7–10 days, depending on project complexity and requirements.",
  },
  {
    q: "Does Amresh Prajapati offer SEO services?",
    a: "Yes, he provides professional SEO services to help websites rank higher on Google and attract more organic traffic.",
  },
  {
    q: "Does he manage Google Business Profiles?",
    a: "Yes, Google Business Profile Management is one of his core services, helping local businesses get found easily on Google Search and Maps.",
  },
  {
    q: "What is his Google review rating?",
    a: "He currently holds a 4.99 rating on Google Reviews, reflecting high client satisfaction.",
  },
  {
    q: "How can I contact Amresh Prajapati?",
    a: "You can call him at +91 90040 68462 or visit his website freelanceramreshprajapatimumbai.in for appointments and inquiries.",
  },
  {
    q: "Is he available for urgent or same-day queries?",
    a: "His business hours are listed as “Open 24 hours,” making him accessible for client queries at flexible times.",
  },
  {
    q: "Does Amresh Prajapati offer cPanel and hosting management?",
    a: "Yes, he provides cPanel management and website maintenance services as part of his web development packages.",
  },
  {
    q: "What type of businesses does he work with?",
    a: "He works with local businesses, exporters, institutes, startups, and individual clients who need professional web presence and digital marketing support.",
  },
  {
    q: "Is Amresh Prajapati good for small business websites?",
    a: "Yes, he specializes in building affordable, fast, and SEO-ready websites specifically tailored for local and small businesses.",
  },
  {
    q: "Does he provide branding services along with web development?",
    a: "Yes, branding and digital marketing services are included in his offerings, helping businesses build a complete online identity.",
  },
  {
    q: "Can Amresh Prajapati redesign an existing website?",
    a: "Yes, he offers website redesign and improvement services to modernize outdated websites and improve performance and SEO.",
  },
  {
    q: "Does he build e-commerce or export business websites?",
    a: "Yes, he has experience developing export and business websites, including premium websites for export-oriented companies.",
  },
  {
    q: "What makes Amresh Prajapati different from other freelancers?",
    a: "His combination of technical expertise (React JS, WordPress, HTML/CSS), SEO knowledge, fast delivery (7–10 days), and strong client reviews sets him apart as a trusted local freelancer.",
  },
  {
    q: "Does he offer website maintenance after project delivery?",
    a: "Yes, ongoing website maintenance services are part of his offerings to keep client websites updated and running smoothly.",
  },
  {
    q: "Is Amresh Prajapati active on social media?",
    a: "Yes, he is active on Facebook, Instagram (@amresh_17), and X (Twitter), where he shares project updates and web development tips.",
  },
  {
    q: "Does he help with mobile-responsive website design?",
    a: "Yes, all websites are built to be modern, fast, and fully responsive across mobile, tablet, and desktop devices.",
  },
  {
    q: "Can I check his previous work/portfolio?",
    a: "Yes, his completed projects and client testimonials are visible on his website freelanceramreshprajapatimumbai.in and his Google Business Profile.",
  },
  {
    q: "Does Amresh Prajapati provide services in Saphale?",
    a: "Yes, he is listed as a Website Designer in Saphale as well, in addition to Virar and Mumbai.",
  },
  {
    q: "What technologies does he specialize in?",
    a: "His core technology stack includes React JS, Node.js, PHP, MySQL and JavaScript. He specializes in building custom CRM systems, custom ERP software and fast, SEO-friendly websites using React JS and WordPress.",
  },
  {
    q: "Is he suitable for institutes or educational businesses?",
    a: "Yes, he has worked with institutes and educational service providers to build professional, informative websites.",
  },
  {
    q: "How do I book an appointment with Amresh Prajapati?",
    a: "Appointments can be booked directly through his website freelanceramreshprajapatimumbai.in, or by calling +91 90040 68462.",
  },
  {
    q: "Why should I choose Amresh Prajapati for my website project?",
    a: "With 4+ years of experience, 70+ delivered projects, a 4.99 Google rating, fast 7–10 day delivery, and expertise in React JS, Node.js, PHP and MySQL, Amresh Prajapati offers a reliable, results-driven web development service for local and remote businesses.",
  },
];

/* ─── FAQ Schema (FAQPage JSON-LD) ───────────────────────────── */
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

/* ─── Accordion item ─────────────────────────────────────────── */
function FaqItem({ item, index, openIndex, toggle }) {
  const isOpen = openIndex === index;

  return (
    <motion.article
      className={`faqItem${isOpen ? " faqItem--open" : ""}`}
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.45 }}
    >
      <button
        type="button"
        className="faqItem__question"
        onClick={() => toggle(index)}
        aria-expanded={isOpen}
        aria-controls={`faq-panel-${index}`}
      >
        <span className="faqItem__num">
          {String(index + 1).padStart(2, "0")}
        </span>
        <h3>{item.q}</h3>
        <span className="faqItem__icon" aria-hidden="true">
          {isOpen ? <FaMinus /> : <FaPlus />}
        </span>
      </button>

      <div id={`faq-panel-${index}`} className="faqItem__panel" role="region">
        <p>{item.a}</p>
      </div>
    </motion.article>
  );
}

/* ─── Page ───────────────────────────────────────────────────── */
export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => setOpenIndex(openIndex === i ? -1 : i);

  /* Split into two columns — 15 questions each side */
  const midPoint = Math.ceil(faqs.length / 2);
  const leftColumn = faqs.slice(0, midPoint);
  const rightColumn = faqs.slice(midPoint);

  return (
    <>
      <Helmet>
        <title>FAQs | Website Design & Development Questions | Amresh Prajapati</title>
        <meta
          name="description"
          content="30 frequently asked questions about hiring freelance website developer Amresh Prajapati in Virar West & Mumbai — services, pricing, delivery time, React JS, WordPress, SEO, hosting and support."
        />
        <meta
          name="keywords"
          content="website developer FAQ, hire web developer Mumbai questions, website development cost Virar, how long to build website India, freelance web developer Virar West, Amresh Prajapati FAQ"
        />
        <link rel="canonical" href="https://freelanceramreshprajapatimumbai.in/faq" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="FAQs | Website Design & Development Questions | Amresh Prajapati"
        />
        <meta
          property="og:description"
          content="Answers to 30 common questions about website pricing, timelines, React JS & WordPress development, SEO, hosting and post-launch support by Amresh Prajapati."
        />
        <meta property="og:url" content="https://freelanceramreshprajapatimumbai.in/faq" />
        <meta property="og:image" content="https://freelanceramreshprajapatimumbai.in/og-image.jpg" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:site_name" content="Amresh Prajapati" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="FAQs | Website Design & Development Questions | Amresh Prajapati"
        />
        <meta
          name="twitter:description"
          content="Answers to 30 common questions about website pricing, timelines, React JS & WordPress development, SEO, hosting and post-launch support by Amresh Prajapati."
        />
        <meta name="twitter:image" content="https://freelanceramreshprajapatimumbai.in/og-image.jpg" />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      {/* HERO — full width */}
      <section className="faqHero">
        <div className="faqHero__glow faqHero__glow--one" />
        <div className="faqHero__glow faqHero__glow--two" />

        <motion.div
          className="faqHero__content"
          variants={fadeUp}
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.65 }}
        >
          <span className="faqTag">
            <FaQuestionCircle /> FAQ's
          </span>

          <h1>
            Frequently Asked <span>Questions</span>
          </h1>

          <p>
            Everything you need to know about working with me — services,
            pricing, process, timelines, technology and support. Can't find
            your answer? Message me anytime.
          </p>
        </motion.div>
      </section>

      {/* ACCORDIONS — two columns, 15 per side */}
      <section className="faqSection">
        <div className="faqContainer">
          <div className="faqGrid">
            <div className="faqCol">
              {leftColumn.map((item, i) => (
                <FaqItem
                  key={item.q}
                  item={item}
                  index={i}
                  openIndex={openIndex}
                  toggle={toggle}
                />
              ))}
            </div>

            <div className="faqCol">
              {rightColumn.map((item, i) => (
                <FaqItem
                  key={item.q}
                  item={item}
                  index={i + midPoint}
                  openIndex={openIndex}
                  toggle={toggle}
                />
              ))}
            </div>
          </div>

          {/* CTA */}
          <motion.div
            className="faqCta"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="faqTag">
              <FaCheckCircle /> Still Have Questions?
            </span>

            <h2>
              Let's Discuss Your <span>Project</span>
            </h2>

            <p>
              Get answers specific to your business idea and a free quote.
              Fast replies on WhatsApp and phone.
            </p>

            <div className="faqCta__actions">
              <a
                href="https://wa.me/919004068462?text=Hi%20Amresh%2C%20I%20have%20a%20question%20about%20your%20services"
                target="_blank"
                rel="noopener noreferrer"
                className="faqBtn faqBtn--whatsapp"
              >
                <FaWhatsapp /> Chat on WhatsApp
              </a>

              <Link to="/contact" className="faqBtn faqBtn--primary">
                <FaRocket /> Contact Me <FaArrowRight />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
}
